import { c as _c } from "react/compiler-runtime";
import { useIsVisible } from "@website/hooks/is-visible";
import { FabMenuItemsTypes, FabMenuPropertiesTypes } from "@website/ui/fab-menu/fab-bar.type";
import { useTopBar } from "@website/ui/fab-menu/fab-menu.hook";
import styles from "@website/ui/fab-menu/fab-menu.module.scss";
import { useEffect } from "react";
export const FabMenu = properties => {
  const $ = _c(19);
  const {
    items,
    className,
    eventToTracking
  } = properties;
  const {
    scrolledItem,
    handleClick
  } = useTopBar(properties);
  const {
    reference,
    inView
  } = useIsVisible();
  let t0;
  if ($[0] !== eventToTracking || $[1] !== scrolledItem) {
    t0 = () => {
      if (process.env.NEXT_PUBLIC_APP_NAME === "villa" && scrolledItem === "\u0641\u0636\u0627\u0647\u0627\u06CC \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647") {
        eventToTracking?.();
      }
    };
    $[0] = eventToTracking;
    $[1] = scrolledItem;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== scrolledItem) {
    t1 = [scrolledItem];
    $[3] = scrolledItem;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== reference) {
    t2 = <div className={styles["fake-element"]} ref={reference} />;
    $[5] = reference;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `${styles.layout} ${className && className} ${inView ? "hidden" : "block"}`;
  let t4;
  if ($[7] !== handleClick || $[8] !== items || $[9] !== scrolledItem) {
    t4 = items?.map(item => <div className={`${styles.container__item} ${scrolledItem === item?.title ? styles.container__item__clicked : styles["container__item__not-clicked"]}`} key={item.selector} onClick={handleClick(item)}>{item.title}</div>);
    $[7] = handleClick;
    $[8] = items;
    $[9] = scrolledItem;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div className={styles.container}>{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <>{t2}{t6}</>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};